import { INavbarItem } from "../Interfaces/NavbarInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import {
  IChangePassFormValues,
  IGetTime,
  IGetUserInfo,
} from "../Interfaces/headerInterfaces";
import { getRequest, putRequest } from "./requestTemplates";

export const getNavbar = (): Promise<Array<INavbarItem>> =>
  getRequest("/v1/general/getNavbar");

export const getTime = (): Promise<IGetTime> =>
  getRequest("/v1/general/getTime");

export const getUserInfo = (): Promise<IGetUserInfo> =>
  getRequest("/v1/general/getUserInfo");

export const changePassword = (
  formValues: IChangePassFormValues
): Promise<Packet<boolean>> =>
  putRequest("/v1/general/ChangePassword", formValues);
